import * as React from 'react';
import { Component } from 'react';
import { ApplicationState } from 'store/rootReducer';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import i18n from 'i18n';
import AnalyticsEventList from 'views/Analytics/AnalyticsMockService/Inspection/RequestDetail/EventList/AnalyticsEventList';
import { InspectionViewEvent } from 'types/rest/analyticsTypes';
import _ from 'lodash';

interface MatchingDetailsProps {
  details: Details;
  executionSteps: InspectionViewEvent[];
}

export interface Details {
  serviceImage: string;
  session: string;
  matchType: string;
  vseRespondFrom: string;
  transactionId?: string | null;
}

class MatchingDetails extends Component<AllProps> {
  render() {
    return (
      <Row>
        <Col xs={3} xl={2} style={{ maxHeight: '100vh', overflow: 'auto' }}>
          <div className="block-example border border-gray">
            <div className="mb-4 p-4 block-example border-bottom border-gray text-center">
              <h2 className="mb-0">{i18n.t('analytics:inspection.matchingDetails.whatHappened')}</h2>
            </div>

            <div className="pl-4 pr-4">
              <div className={'mb-4'}>
                <strong>{i18n.t('analytics:inspection.matchingDetails.serviceImage')}</strong>
                <br />
                {this.props.details.serviceImage}
              </div>
              <div className={'mb-4'}>
                <strong>{i18n.t('analytics:inspection.matchingDetails.session')}</strong>
                <br />
                {this.props.details.session}
              </div>
              <div className={'mb-4'}>
                <strong>{i18n.t('analytics:inspection.matchingDetails.matchType')}</strong>
                <br />
                {this.props.details.matchType}
              </div>
              <div className={'mb-4'}>
                <strong>{i18n.t('analytics:inspection.matchingDetails.vseRespondFrom')}</strong>
                <br />
                {this.props.details.vseRespondFrom}
              </div>
              {!_.isNil(this.props.details.transactionId) && (
                <div className={'mb-4'}>
                  <strong>{i18n.t('analytics:inspection.matchingDetails.txnId')}</strong>
                  <br />
                  {this.props.details.transactionId}
                </div>
              )}
            </div>
          </div>
        </Col>

        <Col xs={9} xl={10}>
          <AnalyticsEventList key={'eventGroup'} executionSteps={this.props.executionSteps} eventGroupName="EVENT" />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({}: ApplicationState) => ({});

type MapToStateProps = ReturnType<typeof mapStateToProps>;
type AllProps = MapToStateProps & MatchingDetailsProps;

export default connect(mapStateToProps)(MatchingDetails);
